<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import InputText from 'primevue/inputtext';
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from "axios";
import Swal from "sweetalert2";
import Dropdown from 'primevue/dropdown';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: "lessons",
  inject: {
    courseCtx: { default: null },
  },
  data() {
    return {
      v$: useVuelidate(),
      type: this.$route.params.type || this.$route.meta.type,
      gradeSlug: this.$route.params.gradeSlug,
      courseId: this.$route.params.courseId ?? null,
      title: "",
      description: "",
      imageEntry: "",
      fileData: "",
      formSending: false,
      branch: null,
      branches: [],
      lesson: null,
      lessons: [],
      lessonId: this.$route.params.id,
    };
  },
  components: {
    Breadcrumb,
    InputText,
    Dropdown
  },
  validations() {
    return {
      title: { required },
      // description: { required },
      // branch: { required },
    };
  },
  computed: {
    isCourseScope() { return !!this.courseId; },
    typeSegment() {
      switch (this.type) {
        case 'branch': return 'branches';
        case 'unit': return 'units';
        case 'lesson': return 'lessons';
        default: return '';
      }
    },
    basePath() {
      return this.isCourseScope
          ? `/courses/${this.courseId}/${this.typeSegment}`
          : `/${this.type}/${this.gradeSlug}`;
    },
    breadcrumbs() {
      if (this.isCourseScope) {
        const base = this.courseCtx?.breadcrumbBase ?? [];
        return [
          ...base,
          { name: this.typeLabel, path: this.basePath },
          { name: `تعديل ${this.typeLabel}`, path: `${this.basePath}/edit/${this.lessonId}` },
        ];
      }
      return [
        { name: 'الرئيسية', path: '/' },
        { name: this.typeLabel, path: `/${this.type}/${this.gradeSlug}` },
        { name: `أضافه ${this.typeLabel}`, path: `/${this.type}/${this.gradeSlug}/add` },
      ];
    },
    typeLabel() {
      switch (this.type) {
        case 'branch':
          return 'الفرع';
        case 'unit':
          return 'الوحدة';
        case 'lesson':
          return 'الدرس';
        default:
          return '';
      }
    },
    gradeStore() { return useGradeStore(); },
    resolvedGrade() {
      const slug = this.gradeSlug;
      return this.gradeStore.activeGrades.find(g => g.slug === slug)
          || this.gradeStore.allGrades.find(g => g.slug === slug)
          || null;
    },
    gradeId() {
      return this.resolvedGrade?.id ?? null;
    },
    typeNumber() {
      switch (this.type) {
        case 'branch':
          return 1;
        case 'unit':
          return 2;
        case 'lesson':
          return 3;
        default:
          return null;
      }
    }
  },
  methods: {
    onFileChange(event) {
      this.fileData = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(this.fileData);
      reader.onload = () => (this.imageEntry = reader.result);
    },
    showLesson() {
      axios
          .get(`/lessons/${this.lessonId}`)
          .then((response) => {
            const lesson = response.data;
            this.title = lesson.title;
            this.description = lesson.description;
            if (lesson.image) {
              this.imageEntry = lesson.image;
            }
            if (lesson.type === 2 && lesson.parent) {
              this.branch = {
                id: lesson.parent.id,
                title: lesson.parent.title
              };
              // this.fetchLessons();
            }
            if (lesson.type === 3 && lesson.parent) {
              this.lesson = lesson.parent;

              // Fetch the branch of the lesson
              axios
                  .get(`/lessons/${this.lesson.id}`)
                  .then((res) => {
                    if (res.data.parent) {
                      this.branch = {
                        id: res.data.parent.id,
                        title: res.data.parent.title
                      };
                      this.lesson = {
                        id: res.data.id,
                        title: res.data.title
                      };
                      this.fetchLessons();
                    }
                  })
                  .catch((err) => {
                    // Handle error if needed
                  });
            }
          })
          .catch((error) => {
            Swal.fire({
              position: "center",
              icon: "error",
              title: error.response.data.message,
            });
          });
    },
    sendForm() {
      this.v$.$validate();
      if (!this.v$.$error) {
        const formData = new FormData();
        formData.append('title', this.title);
        formData.append('description', this.description);
        
        // formData.append('type', this.typeNumber);
        if (this.fileData) {
          formData.append('image', this.fileData);
        }
        if (this.branch && this.typeNumber === 2) {
          formData.append('parent_id', this.branch.id);
        }
        if (this.lesson && this.typeNumber === 3) {
          formData.append('parent_id', this.lesson.id);
        }
        this.formSending = true;

        axios
            .post(`/lessons/${this.lessonId}?_method=PUT`, formData)
            .then((response) => {
              this.formSending = false;
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم التعديل بنجاح",
              });
              this.$router.push(this.basePath);
            })
            .catch((error) => {
              this.formSending = false;
              Swal.fire({
                position: "center",
                icon: "error",
                title: error.response.data.message,
              });
            });
      }
    },
    fetchBranch() {
      const params = this.isCourseScope
          ? { type: 1, course_id: this.courseId }
          : { type: 1, academic_year_id: this.gradeId };
      axios
          .get('/lessons', { params })
          .then((response) => {
            this.branches = response.data.data.map(branch => ({
              id: branch.id,
              title: branch.title
            }));
          })
          .catch(() => {});
    },
    fetchLessons() {
      const branchId = this.branch.id;
      const params = this.isCourseScope
          ? { type: 2, course_id: this.courseId, parent_id: branchId }
          : { type: 2, academic_year_id: this.gradeId, parent_id: branchId };
      axios
          .get('/lessons', { params })
          .then((response) => {
            this.lessons = response.data.data.map(lesson => ({
              id: lesson.id,
              title: lesson.title
            }));
          })
          .catch(() => {});
    },
  },
  async mounted() {
    if (!this.isCourseScope) {
      if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
      if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    }
    if (this.typeNumber === 2 || this.typeNumber === 3) {
      this.fetchBranch();
    }
    this.showLesson();
  }
}
</script>

<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">
    <form class="row" @submit.prevent="sendForm()">
      <div class="col-lg-4 col-md-6 col-12 mb-4" v-if="typeNumber === 2 || typeNumber === 3">
        <div class="d-flex flex-column gap-2">
          <label for="branch">الفروع</label>
          <Dropdown v-model="branch" :options="branches" showClear optionLabel="title" placeholder="اختر الفرع" class="w-full md:w-14rem" @update:model-value="fetchLessons" />
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-12 mb-4" v-if="typeNumber === 3">
        <div class="d-flex flex-column gap-2">
          <label for="lesson">الدروس</label>
          <Dropdown v-model="lesson" :options="lessons" showClear optionLabel="title" placeholder="اختر الدرس" class="w-full md:w-14rem" />
        </div>
      </div>
      <div :class="`${typeNumber === 2 ? 'col-lg-8 col-md-6' : typeNumber === 3 ? 'col-lg-4' : ''} mb-4`"></div>
      <div class="col-lg-4 col-md-6 col-12 mb-4">
        <div class="d-flex flex-column gap-2">
          <label for="title">اسم {{ typeLabel }}</label>
          <InputText id="title" v-model="title" aria-describedby="title-help" />
          <span class="text-danger" v-if="v$.title.$error">برجاء ادخال اسم {{ typeLabel }}</span>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-12">
        <div class="d-flex flex-column gap-2">
          <label for="description">وصف {{ typeLabel }}</label>
          <InputText id="description" v-model="description" aria-describedby="description-help" />
          <!-- <span class="text-danger">برجاء ادخال وصف {{ typeLabel }}</span> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-12 mb-4">
        <div class="d-flex flex-column gap-2">
          <label for="certificateImage">صورة {{ typeLabel }}</label>
          <label for="certificateImage" class="upload_img btn primaryButtonOutline">
            <p class="mb-0 mx-2" v-if="imageEntry == ''">برجاء رفع صورة {{ typeLabel }}</p>
            <p class="mb-0 mx-2" v-else-if="imageEntry">{{ fileData.name }}</p>
            <i class="pi pi-cloud-upload border-2 border-circle text-8xl text-400 border-400" />
          </label>
          <input
              type="file"
              id="certificateImage"
              class="form-control"
              @change="onFileChange"
              hidden
              accept="image/png, image/gif, image/jpeg, image/jpg"
          />
        </div>
        <!--                    <span class="text-danger" v-if="v$.fileData.$error">برجاء رفع صورة الشهادة</span>-->
      </div>
      <div class="col-lg-4 col-md-6 col-12">
        <label for="button" class="non-visible">ارسال</label>
        <button type="submit" class="btn primaryButton w-100" :disabled="formSending"><i class="pi pi-spin pi-spinner-dotted" v-if="formSending"></i> {{ formSending ? 'جاري الارسال...' : 'إرسال' }}</button>
      </div>
    </form>
  </div>
</template>

<style scoped>

</style>